import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { AxiosResponseAndError,ResponseType } from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Project } from "../query/useProjectQuery";
import { QUERY_KEYS } from "../query/querykeys";

type ProjectDuplicateResponseType = ResponseType<Project>;
function useProjectDuplicateMutation() {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    AxiosResponseAndError<ProjectDuplicateResponseType>["response"],
    AxiosResponseAndError<ProjectDuplicateResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.put<ProjectDuplicateResponseType>(
        `${requestURLs.project}/duplicate-project/${data}`,
        data
      ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getProjects],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getProjectsNocal],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.portfolioDashboard],
        }),
      ]);
    },
  });

  return mutation;
}
export default useProjectDuplicateMutation;
